export default {
  message: {
    "error": "एक त्रुटि हुई!",
    "Sorrysomeerrorsoccurred": "क्षमा करें, कुछ त्रुटियाँ हुईं",
    "quit": "बंद करें",
    "language": "भाषा",
    "Youcanchangethelanguagehere": "आप यहाँ भाषा बदल सकते हैं!",
    "current": "वर्तमान",
    "home": "घर",
    "friends": "मित्र",
    "wallet": "वॉलेट",
    "aboutus": "हमारे बारे में",
    "Sharewithfriends": "मित्रों के साथ साझा करें",
    "copyFailure": "कॉपी विफलता",
    "copySuccess": "कॉपी सफलता",
    "Claimreward": "इनाम प्राप्त करें",
    "DailyLogin": "दैनिक लॉगिन",
    "noInvitationsYet": "अभी तक कोई निमंत्रण नहीं",
    "LoadMore": "और लोड करें",
    "WatchAD": "विज्ञापन देखें",
    "continue": "जारी रखें",
    "Congratulations": "बधाई हो",
    "MyFriends": "मेरे मित्र",
    "Invitefriends": "मित्रों को आमंत्रित करें",
    "Invitepremiumfriends": "प्रीमियम मित्रों को आमंत्रित करें",
    "DailyTasks": "दैनिक कार्य",
    "inviteDesc": "हर मित्र के लिए +{num} ${name}",
    "DailyTasksDesc": "अधिक ${name} पाने के लिए कार्य पूर्ण करें",
    "SponsorsandPartners": "प्रायोजक और साझेदार",
    "Receivingwallet": "प्राप्त वॉलेट",
    "Enterwalletaddress": "{name} वॉलेट पता दर्ज करें",
    "Claim": "इनाम प्राप्त करें",
    "Booster": "बूस्टर",
    "RentPeriod": "किराए की अवधि",
    "days30": "30 दिन",
    "days": "दिन",
    "Dailyprofit": "दैनिक लाभ",
    "Totalprofit": "कुल लाभ",
    "Quantity": "मात्रा",
    "RentPrice": "किराया मूल्य",
    "RentMiner": "खनन किराए पर लें",
    "Insufficient": "अपर्याप्त ${name}",
    "InsufficientMsg": "{num} ${name1} की आवश्यकता है, मित्रों को आमंत्रित करें या और ${name2} अर्जित करने के लिए कार्य पूर्ण करें।",
    "Settings": "सेटिंग्स",
    "copyid": "आईडी कॉपी करें",
    "UpgradeSuccessfully": "सफलता से अपडेट करें",
    "Name": "नाम",
    "userinfo": "उपयोगकर्ता जानकारी",
    "disconnect": "डिस्कनेक्ट करें",
    "Startmining": "खनन शुरू करें",
    "Welcome": "आपका स्वागत है {name}",
    "Withdrawal": "निकासी",
    "Minimumamount": "न्यूनतम राशि",
    "Networkfee": "नेटवर्क शुल्क",
    "Enteramount": "राशि दर्ज करें",
    "Submit": "सबमिट करें",
    "MinimumTip": "निकासी राशि बहुत छोटी है। न्यूनतम निकासी राशि: {num}",
    "MaximumTip": "अपर्याप्त राशि, आप अधिकतम {num} राशि निकाल सकते हैं",
    "SubmittedTip": "सबमिट कर दिया गया, 30-60 कार्यदिवसों के भीतर प्रोसेस होने की अपेक्षा है",
    "WebSubmittedTip": "सबमिट कर दिया गया, 24-48 घंटों के भीतर प्रोसेस होने की अपेक्षा है",
    "WithdrawStatus": "स्थिति",
    "Submissiontime": "सबमिशन का समय",
    "WithdrawAwaitTip": "* इसका अनुमान 30-60 कार्यदिवस लगने का है। अधिक दोस्तों को आमंत्रित करने से समीक्षा प्रक्रिया तेजी से हो सकती है।",
    "WebWithdrawAwaitTip": "* इसका अनुमान 24-48 घंटों लगने का है। अधिक दोस्तों को आमंत्रित करने से समीक्षा प्रक्रिया तेजी से हो सकती है।",
    "Processing": "प्रसंस्करण",
    "Success": "सफलता",
    "Rejection": "अस्वीकृति",
    "Amount": "राशि",
    "Numberoffriends": "दोस्तों की संख्या: {now}/{limit}",
    "InviteTip": "अपनी पहली निकासी करने के लिए, आपको {limit} दोस्तों को खनन ऐप में शामिल होने के लिए आमंत्रित करना होगा।",
    "openonphone": "अपने फोन पर यह लिंक खोलें।",
    "claimTip": "जो राशि प्राप्त करने के लिए है, वह बहुत छोटी है। प्राप्त करने के लिए न्यूनतम राशि है: {num}",
    "WalletBalance": "वॉलेट बैलेंस",
    "Withdraw": "निकासी",
    "SetWalletAddress": "वॉलेट पता सेट करें",
    "WithdrawalRecord": "निकासी रिकॉर्ड",
    "Norecords": "कोई रिकॉर्ड नहीं",
    "Whatis": "{name} क्या है?",
    "All": "सभी",
    "save": "सहेजें",
    "successWithdrawal": "निकासी प्राप्त कर ली गई है {num}",
    "secondsago": "{time} सेकंड पहले",
    "Loading": "लोड हो रहा है...",
    "PaymentConfirming": "लेन-देन की स्थिति की जांच कर रहे हैं...",
    "Check": "जांचें",
    "CheckFail": "लेन-देन पूरा नहीं हुआ। कृपया 5 सेकंड बाद पुनः जांचें।",
    "Addname": "अपने नाम में '{name}' जोड़ें",
    "Restattcheck": "जांचने के लिए ऐप को फिर से चालू करें",
    "Copyname": "'{name}' कॉपी करें",
    "SubmissionFailed": "सबमिशन विफल, कृपया बाद में फिर से प्रयास करें",
    "WithdrawalReview": "निकासी समीक्षा",
    "shop": "दुकान",
    "topurchase": "खरीददारी के लिए दुकान पर जाएँ",
    "shopDesc": "सीमित उपलब्धता—इसे प्राप्त करें इससे पहले कि वे गायब हो जाएं!",
    "select_payment_method": "भुगतान विधि चुनें",
    "total_amount": "कुल राशि",
    "creating_order": "आर्डर बना रहे हैं...",
    "order_created": "आर्डर बना दिया गया",
    "order_status": "आर्डर की स्थिति",
    "claim": "इनाम प्राप्त करें",
    "payment_success": "भुगतान सफल",
    "payment_failed": "भुगतान विफल",
    "payment_cancelled": "भुगतान रद्द",
    "opening_payment": "भुगतान खुल रहा है...",
    "payment_status": "भुगतान स्थिति",
    "create_order_failed": "ऑर्डर बनाना विफल",
    "creating_ton_order": "TON ऑर्डर बना रहे हैं...",
    "next_step": "अगला चरण",
    "use_ton_payment": "TON भुगतान का उपयोग करें",
    "start_transaction": "लेनदेन शुरू करें",
    "connect_wallet": "वॉलेट कनेक्ट करें",
    "address": "पता",
    "amount_ton": "राशि TON",
    "copy": "कॉपी करें",
    "amount": "राशि",
    "wallet_address": "वॉलेट पता",
    "comment_memo": "टिप्पणी नोट",
    "you_can_choose_to_connect_wallet_to_pay": "आप भुगतान करने के लिए वॉलेट कनेक्ट करने का विकल्प चुन सकते हैं",
    "or_manually_transfer_to_the_above_address": "या ऊपर दिए गए पते पर मैन्युअल रूप से स्थानांतरित करें (ध्यान दें कि राशि और नोट बिल्कुल समान होनी चाहिए)",
    "transaction_success": "लेनदेन सफल",
    "transaction_failed": "लेनदेन विफल",
    "transaction_error": "लेनदेन त्रुटि",
    "transaction_status": "लेनदेन स्थिति",
    "transaction_id": "लेनदेन आईडी",
    "transaction_amount": "लेनदेन राशि",
    "transaction_status_desc": "लेनदेन स्थिति विवरण",
    "payment_status_tip": "कृपया भुगतान की पुष्टि होने की प्रतीक्षा करें",
    "Applyforwithdrawal": "निकासी के लिए आवेदन करें",
    "Withdrawalunlock": "निकासी अनलॉक हो रही है",
    "Close": "बंद करें",
    "Delivering": "कई प्राप्तकर्ताओं के कारण, आपका एयरड्रॉप 15-20 कार्य दिवसों में आने की अपेक्षा है",
    "Duetothelargenumber": "आपको निकासी अनलॉक करने के लिए {num} दोस्तों को आमंत्रित करना होगा",
    "WithdrawalunlockTip": "",
    "select_network": "नेटवर्क चुनें",
    "confirm": "पुष्टि करें",
    "switching_network": "नेटवर्क बदल रहा है...",
    "network_switched": "नेटवर्क बदल गया",
    "use_usdt_payment": "USDT भुगतान का उपयोग करें",
    "or_manually_transfer_to_the_above_address_usdt": "ऊपर दिए गए पते पर मैन्युअल रूप से ट्रांसफर करें (ध्यान दें कि राशि और पता बिल्कुल समान होना चाहिए)",
    "chain_type": "नेटवर्क",
    "check_transaction_status": "लेनदेन की स्थिति की जांच करें",
    "transaction_wait": "लेनदेन प्रक्रिया में है। आप ऐप से बाहर जा सकते हैं। जब यह पूरा होगा तो एक संदेश आपको सूचित करेगा।",
    "twa_pay_tip_with_memo": "कृपया सुनिश्चित करें कि पता, राशि और मेमो ट्रांसफर के लिए एकसमान हैं।",
    "twa_pay_tip": "कृपया सुनिश्चित करें कि पता और राशि ट्रांसफर के लिए सही हैं।",
    "creating_usdt_order": "USDT आदेश बना रहे हैं...",
    "affiliate_programs": "सहबद्ध कार्यक्रम",
    "affiliate_programs_description": "माइनिंग ऐप में शामिल होने के लिए दोस्तों को आमंत्रित करें और पुरस्कार अर्जित करें।",
    "commission_details": "कमीशन विवरण",
    "no_commission_records": "कोई कमीशन रिकॉर्ड नहीं",
    "commission_list": "कमीशन सूची",
    "input_amount": "राशि डालें",
    "max": "अधिकतम",
    "commission_input_amount": "कमीशन राशि डालें",
    "min_commission": "न्यूनतम निकासी राशि {num} है",
    "WithdrawalSuccess": "निकासी सफल",
    "WithdrawalFailed": "निकासी असफल",
    "WithdrawalProcessing": "निकासी प्रक्रिया में",
    "award": "पुरस्कार",
    "level": "स्तर",
    "Share_to_group": "समूह में साझा करें",
    "Exchange": "विनिमय",
    "balance_not_enough": "शेष राशि पर्याप्त नहीं है, आप केवल {num} {coin} का विनिमय कर सकते हैं",
    "exchange_fail": "विनिमय विफल",
    "exchange_success": "विनिमय सफल",
    "you_will_receive": "आपको प्राप्त होगा",
    "ShareToGroups": "समूहों में साझा करें",
    "Numberofgroups": "समूहों की संख्या: {now}/{limit}",
    "Confirm": "पुष्टि करें",
    "ShareToGroupsDesc": "अधिक {name} प्राप्त करने के लिए समूहों में साझा करें",
    "TokenAddress": "कृपया निकासी विवरण दर्ज करें जैसे कि एक्सचेंज आईडी या USDT पता",
    "CashAddress": "कृपया निकासी विवरण दर्ज करें जैसे कि बैंक कार्ड संख्या या USDT पता",
    "Cancel": "रद्द करें",
    "min_withdrawal_amount": "न्यूनतम निकासी राशि {num} {coin} है",
    "max_withdrawal_amount": "अधिकतम निकासी राशि {num} {coin} है",
    "withdrawal_failed": "निकासी विफल",
    "withdrawal_success": "निकासी सफल",
    "PayNow": "अभी भुगतान करें",
    "PaySkip": "तुरंत निकासी के लिए {num} का भुगतान करें",
    "NumberofGroups": "समूहों की संख्या: {now}/{limit}",
    "SendMessage": "संदेश भेजें",
    "NumberofShares": "शेयर की संख्या: {now}/{limit}",
    "NumberofTasks": "कार्य की संख्या: {now}/{limit}",
    "CompleteTask": "कार्य पूरा करें",
    "PleaseEnterValidAmount": "कृपया मान्य राशि दर्ज करें",
    "PleaseEnterValidEmail": "कृपया मान्य ईमेल दर्ज करें",
    "Feedback": "प्रतिक्रिया",
    "Inputfeedbackcontent": "प्रतिक्रिया सामग्री दर्ज करें",
    "Submitfeedback": "प्रतिक्रिया सबमिट करें",
    "Pleaseenteravalidemailaddress": "कृपया मान्य ईमेल पता दर्ज करें",
    "Pleaseenteryouremailaddress": "कृपया अपना ईमेल पता दर्ज करें",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "आपने आज पहले ही प्रतिक्रिया दी है, कृपया कल वापस आएं",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "प्रतिक्रिया सफलतापूर्वक सबमिट की गई, आपके मूल्यवान फीडबैक के लिए धन्यवाद",
    "Feedback_submission_failed_please_retry": "प्रतिक्रिया सबमिट करने में विफल, कृपया पुन: प्रयास करें",
    "ContactUs": "संपर्क करें",
    "XRPAddress": "कृपया सक्रिय XRP चेन वॉलेट पते (MEMO सहित) को भरें, अन्यथा आप नकद निकालने में असमर्थ होंगे।",
    "Accelerated": "त्वरित",
    "Accelerated_withdrawals_success": "त्वरित निकासी सफलतापूर्वक",
    "login": "लॉगिन",
    "register": "रजिस्टर",
    "login_with_google": "गूगल के साथ लॉगिन करें",
    "or": "या",
    "email": "ईमेल",
    "password": "पासवर्ड",
    "no_account": "क्या आपके पास कोई खाता नहीं है",
    "click_to_go": "क्लिक करें ताकि",
    "have_account": "पहले से ही एक खाता है",
    "go_to": "जाएँ",
    "invite_code": "निमंत्रण कोड",
    "optional": "वैकल्पिक",
    "google_login_not_ready": "गूगल लॉगिन तैयार नहीं है, कृपया बाद में पुनः प्रयास करें",
    "password_too_long": "पासवर्ड बहुत लंबा है",
    "weak": "कमज़ोर",
    "medium": "मध्यम",
    "strong": "मजबूत",
    "login_success": "लॉगिन सफल",
    "login_failed": "लॉगिन विफल",
    "please_input_email": "कृपया अपना ईमेल दर्ज करें",
    "invalid_email": "अमान्य ईमेल प्रारूप",
    "please_input_password": "कृपया अपना पासवर्ड दर्ज करें",
    "password_length_6_to_16": "पासवर्ड 6-16 वर्ण होना चाहिए",
    "account_or_password_error": "खाता या पासवर्ड त्रुटि",
    "register_success": "पंजीकरण सफल",
    "register_failed": "पंजीकरण विफल",
    "save_error": "सहेजने में त्रुटि, कृपया बाद में फिर से प्रयास करें",
    "ShareToFriends": "दोस्तों के साथ साझा करें",
    "login_first": "कृपया पहले लॉगिन करें",
    "WalletBscError": "❌ अमान्य BNB Chain वॉलेट पता।",
    "DownloadWallet": "वॉलेट डाउनलोड करें",
    "AddToHomeScreen": "होम स्क्रीन में {appName} जोड़ें",
    "TapShareInToolbar": "टूलबार में टैप करें",
    "SelectAddToHomeScreen": "होम स्क्रीन में जोड़ें चुनें",
    "OpenToolbar": "टूलबार खोलें",
    "ClaimFailed": "इनाम प्राप्त करना विफल, कृपया बाद में पुनः प्रयास करें",
    "guest_login": "अतिथि लॉगिन",
    "please_input_phone": "कृपया अपना फोन नंबर दर्ज करें",
    "email_error_1": "कृपया अपना ईमेल दर्ज करें",
    "email_error_2": "कृपया एक मान्य ईमेल पता दर्ज करें",
    "email_error_3": "अतिथि ईमेल की अनुमति नहीं है, कृपया एक वास्तविक ईमेल का उपयोग करें",
    "phone": "फोन",
    "phone_error_1": "कृपया अपना फोन नंबर दर्ज करें",
    "phone_error_2": "कृपया एक मान्य फोन नंबर दर्ज करें",
    "update_info": "जानकारी अपडेट करें",
    "update_success": "अपडेट सफल",
    "update_failed": "अपडेट असफल, कृपया बाद में कोशिश करें",
    "cancel": "रद्द करें",
    "guest_credentials_title": "खाता सूचना",
    "guest_credentials_warning": "कृपया अपना खाता और पासवर्ड बचाने के लिए एक स्क्रीनशॉट लें। यदि खो जाए, तो आपकी कमाई को पुनर्प्राप्त नहीं किया जा सकेगा!",
    "i_have_saved": "मैंने बचा लिया है",
    "account": "खाता",
    "view_credentials": "प्रमाणपत्र देखें",
    "miner_max_reached": "आप इस खननकर्ता की अधिकतम संख्या पर पहुँच चुके हैं"
}};